import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const FormatDays = ({
    schedule: { days, isEveryDay }
}) => {
    const intl = useIntl();

    if (isEveryDay) {
        return <b>{intl.formatMessage({ id: 'App.everyDay' })}</b>;
    }

    return (
        <span>
            {Boolean(days.length) && intl.formatMessage({ id: 'App.in' })}
            {' '}
            {days.map((day) => intl.formatMessage({ id: `App.${day}` })).join(', ')}
        </span>
    );
};

FormatDays.propTypes = {
    schedule: PropTypes.shape({
        days: PropTypes.arrayOf(PropTypes.string).isRequired,
        isEveryDay: PropTypes.bool.isRequired
    })
};

export default FormatDays;
